import { InternalAxiosRequestConfig } from 'axios';
import { i18n } from '@/shared/i18n';
import { resolveLocale } from '@/shared/i18n/locale-resolution';

/**
 * The language the user is reading the app in, as the base code the backend
 * carries. Read per request rather than captured, so a switch applies to the
 * very next call, including streams whose transport outlives the switch.
 */
export function currentRequestLocale(): string {
  return resolveLocale({ preferred: i18n.language ? [i18n.language] : [] });
}

/**
 * States the app's locale on every outbound request instead of inheriting
 * whatever Accept-Language the browser derives from the operating system,
 * so what the backend resolves against is an input this app controls.
 */
export const acceptLanguageRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  config.headers['Accept-Language'] = currentRequestLocale();
  return config;
};
